<template>
    <div class="enter-email position-relative">
        <div v-if="loading" class="loader d-flex align-items-center text-center justify-content-center">
            <div class="spinner-border" role="status" aria-hidden="true"></div>
            </div>
            <div class="row mb-2">
                <div class="col-12 col-md-6">
                    <h4>3. Enter Your Email</h4>
                    <input v-model="saveBasketEmail" v-on:change="addEmail" type="email" name="email" id="email" placeholder="Enter Email" class="mb-2 mb-md-0">
                </div>
            </div>
            <div v-if="formErrors" class="alert alert-danger">
                {{formErrors.email[0]}}
            </div>

            <div v-if="message" class="alert alert-success">
                {{message}}
            </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      saveBasketEmail: this.basketEmail,
      formErrors: null,
      message: null,
    };
  },

  props: [
    'basketId',
    'basketEmail'
  ],

  methods: {
    addEmail() {
        this.loading = true;
        this.formErrors = null;
        this.message = null;

        axios.post('/api/v1/basket/addEmail', {
          basketId: this.basketId,
          email: this.saveBasketEmail
        })
        .then(res => {
          if (res.data && res.data.success) {
              this.message = "Email added successfully!";
          }
        })
        .catch(error => {
          this.formErrors = error.response.data.errors;
        })
        .finally(res => {
          this.loading = false;
        });
    }
  },
};

</script>


<style scoped>
    input {
        width: 100%;
    }
</style>
